import { PageModuleData } from "entities/pages/types";
import { Dispatch, SetStateAction } from "react";

export type ModuleDetailsType = {
  brandId: string;
  settingId: string;
  moduleId: string | null;
  moduleData: PageModuleData | null;
  isLoadingSelectedGamesList: boolean;
  isFetchingSelectedGamesList: boolean;
  isLoadingAvailableStudios: boolean;
  availableStudios: { id: number; name: string }[] | undefined;
  handleDrawerClose: () => void;
  selectedTab: ModuleDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<ModuleDetailsTabs>>;
};

export enum ModuleDetailsTabs {
  General,
  Tags,
  SelectedGames,
  StudioOrdering,
  Studios,
  Translations,
}

export enum ManagedTranslations {
  ModuleName = "Module name",
  CardTitle = "Card title",
  CardDescription = "Card description",
  ModuleTitle = "Module title",
  ModuleDescription = "Module description",
  CTAForRegisteredUser = "CTA for registered user",
  CTAForUnauthenticatedUser = "CTA for unregistered user",
}
